// import React from 'react';
// import {
//   Avatar,
//   Box,
//   Button,
//   Card,
//   CardContent,
//   Chip,
//   Divider,
//   Grid,
//   Typography
// } from '@mui/material';
// import { FaEye, FaThumbsUp, FaThumbsDown } from 'react-icons/fa';
// import {
//   PurchaseRequest,
//   AssetRequest,
//   RevaluationRequest,
//   ContributionRequest,
//   SellRequest,
//   TabConfig
// } from './types';
// import {
//   formatCurrency,
//   formatUnits,
//   formatDate,
//   getStatusConfig,
//   getRequestDisplayData
// } from './utils';
// import { useDrawer } from 'components/app/DrawerContext';
// import { SellAssetRequestItem } from 'slices/fundManagementInvestment/simulationDashboardSlice';

// interface RequestCardProps {
//   request:
//     | PurchaseRequest
//     | AssetRequest
//     | RevaluationRequest
//     | ContributionRequest
//     | SellRequest
//     | SellAssetRequestItem;
//   tabConfig: TabConfig;
//   onViewRequest: (
//     request:
//       | PurchaseRequest
//       | AssetRequest
//       | RevaluationRequest
//       | ContributionRequest
//       | SellRequest
//       | SellAssetRequestItem
//   ) => void;
//   onAction: (
//     request:
//       | PurchaseRequest
//       | AssetRequest
//       | RevaluationRequest
//       | ContributionRequest
//       | SellRequest
//       | SellAssetRequestItem,
//     action: 'accept' | 'reject'
//   ) => void;
//   loading?: boolean;
// }

// // ✅ Type guard for SellAssetRequestItem
// const isSellAssetRequest = (req: any): req is SellAssetRequestItem => {
//   return req && 'assetSellId' in req && 'assetId' in req && !('requestId' in req);
// };

// // ✅ Helper to get display data for SellAssetRequestItem
// const getSellAssetRequestDisplayData = (request: SellAssetRequestItem) => {
//   return {
//     title: `Asset ${request.assetId}`,
//     email: request.lastUpdatedBy || 'System',
//     avatar: undefined,
//     amount: parseFloat(request.finalPrice) || 0,
//     units: parseFloat(request.deductions) || 0,
//     createdAt: request.requestDate
//   };
// };

// const RequestCard: React.FC<RequestCardProps> = ({
//   request,
//   tabConfig,
//   onViewRequest,
//   onAction,
//   loading = false
// }) => {
//   // ✅ Add defensive checks for undefined props
//   if (!request || !tabConfig) {
//     console.warn('RequestCard: Missing required props', { request, tabConfig });
//     return null;
//   }

//   // ✅ NEW: Handle SellAssetRequestItem
//   let displayData;
//   if (isSellAssetRequest(request)) {
//     displayData = getSellAssetRequestDisplayData(request);
//   } else {
//     displayData = getRequestDisplayData(request);
//   }

//   const statusConfig = getStatusConfig(request.status);

//   // ✅ Use drawer context for admin state instead of utility function
//   const { fundManagementAdminRight } = useDrawer();
//   const isAdmin = fundManagementAdminRight;

//   console.log('isAdmin in RequestCard:', isAdmin);

//   // ✅ Add defensive checks for displayData and statusConfig
//   if (!displayData || !statusConfig) {
//     console.warn('RequestCard: Failed to get display data or status config');
//     return null;
//   }

//   return (
//     <Card
//       sx={{
//         borderRadius: 2,
//         border: '1px solid #e0e0e0',
//         transition: 'all 0.2s ease',
//         height: '100%',
//         '&:hover': {
//           transform: 'translateY(-2px)',
//           boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
//           border: '1px solid #1976d2'
//         }
//       }}
//     >
//       <CardContent sx={{ padding: 2 }}>
//         {/* Header */}
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'flex-start',
//             marginBottom: 2
//           }}
//         >
//           <Box
//             sx={{
//               display: 'flex',
//               alignItems: 'center',
//               flex: 1,
//               minWidth: 0
//             }}
//           >
//             <Avatar src={displayData.avatar || ''} sx={{ width: 36, height: 36, marginRight: 1.5 }}>
//               {tabConfig.icon || '?'}
//             </Avatar>
//             <Box sx={{ minWidth: 0, flex: 1 }}>
//               <Typography
//                 variant="body2"
//                 sx={{
//                   fontWeight: 500,
//                   fontSize: '0.85rem',
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                   whiteSpace: 'nowrap'
//                 }}
//               >
//                 {displayData.title || 'No Title'}
//               </Typography>
//               <Typography variant="caption" sx={{ color: '#666', fontSize: '0.7rem' }}>
//                 {tabConfig.label || 'Unknown Type'}
//               </Typography>
//             </Box>
//           </Box>
//           <Chip
//             label={statusConfig.label || 'Unknown'}
//             size="small"
//             sx={{
//               backgroundColor: statusConfig.bgColor || '#f5f5f5',
//               color: statusConfig.color || '#333',
//               fontWeight: 500,
//               fontSize: '0.65rem',
//               height: 20
//             }}
//           />
//         </Box>

//         {/* Details */}
//         <Grid container spacing={1} sx={{ marginBottom: 2 }}>
//           <Grid item xs={12}>
//             <Typography variant="caption" sx={{ color: '#666', fontSize: '0.65rem' }}>
//               {isSellAssetRequest(request)
//                 ? 'Updated By'
//                 : 'investorEmailId' in request
//                 ? 'Email'
//                 : 'Fund Manager'}
//             </Typography>
//             <Typography sx={{ fontSize: '0.75rem', fontWeight: 400 }}>
//               {displayData.email || 'N/A'}
//             </Typography>
//           </Grid>

//           <Grid item xs={6}>
//             <Typography variant="caption" sx={{ color: '#666', fontSize: '0.65rem' }}>
//               {isSellAssetRequest(request) ? 'Final Price' : 'Amount'}
//             </Typography>
//             <Typography sx={{ fontSize: '0.8rem', fontWeight: 500, color: '#1976d2' }}>
//               {formatCurrency(displayData.amount || '0')}
//             </Typography>
//           </Grid>

//           <Grid item xs={6}>
//             <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#666' }}>
//               {isSellAssetRequest(request)
//                 ? 'Deductions'
//                 : 'sellUnits' in request
//                 ? 'Sell Units'
//                 : 'investedUnits' in request
//                 ? 'Units'
//                 : 'Cash Used'}
//             </Typography>
//             <Typography sx={{ fontSize: '0.75rem', fontWeight: 400 }}>
//               {isSellAssetRequest(request)
//                 ? formatCurrency(displayData.units || '0')
//                 : 'sellUnits' in request || 'investedUnits' in request
//                 ? formatUnits(displayData.units || '0')
//                 : formatCurrency(displayData.units || '0')}
//             </Typography>
//           </Grid>

//           <Grid item xs={6}>
//             <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#666' }}>
//               Submitted
//             </Typography>
//             <Typography sx={{ fontSize: '0.7rem', fontWeight: 400 }}>
//               {formatDate(displayData.createdAt || new Date().toISOString())}
//             </Typography>
//           </Grid>

//           <Grid item xs={6}>
//             <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#666' }}>
//               Created
//             </Typography>
//             <Typography sx={{ fontSize: '0.7rem', fontWeight: 400 }}>
//               {formatDate(displayData.createdAt || new Date().toISOString())}
//             </Typography>
//           </Grid>

//           {/* ✅ NEW: Show Asset ID for asset sell requests */}
//           {isSellAssetRequest(request) && (
//             <Grid item xs={12}>
//               <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#666' }}>
//                 Asset ID
//               </Typography>
//               <Typography
//                 sx={{
//                   fontSize: '0.75rem',
//                   fontWeight: 400,
//                   overflow: 'hidden',
//                   textOverflow: 'ellipsis',
//                   whiteSpace: 'nowrap'
//                 }}
//               >
//                 {request.assetId}
//               </Typography>
//             </Grid>
//           )}
//         </Grid>

//         <Divider sx={{ marginY: 1.5 }} />

//         {/* Actions */}
//         <Box
//           sx={{
//             display: 'flex',
//             justifyContent: 'space-between',
//             alignItems: 'center'
//           }}
//         >
//           <Button
//             startIcon={<FaEye size={12} />}
//             onClick={() => onViewRequest(request)}
//             sx={{
//               textTransform: 'none',
//               fontSize: '0.65rem',
//               padding: '4px 8px'
//             }}
//           >
//             View
//           </Button>

//           {/* ✅ Show Accept/Reject buttons only for admin users with pending requests */}
//           {isAdmin && request?.status === 'pending' && (
//             <Box sx={{ display: 'flex', gap: 0.5 }}>
//               <Button
//                 variant="contained"
//                 size="small"
//                 startIcon={<FaThumbsUp size={10} />}
//                 onClick={() => onAction(request, 'accept')}
//                 disabled={loading}
//                 sx={{
//                   backgroundColor: '#4caf50',
//                   '&:hover': { backgroundColor: '#45a049' },
//                   textTransform: 'none',
//                   fontSize: '0.65rem',
//                   padding: '4px 8px',
//                   minWidth: 60
//                 }}
//               >
//                 Accept
//               </Button>
//               <Button
//                 variant="outlined"
//                 size="small"
//                 startIcon={<FaThumbsDown size={10} />}
//                 onClick={() => onAction(request, 'reject')}
//                 disabled={loading}
//                 sx={{
//                   color: '#f44336',
//                   borderColor: '#f44336',
//                   '&:hover': { backgroundColor: '#ffebee' },
//                   textTransform: 'none',
//                   fontSize: '0.65rem',
//                   padding: '4px 8px',
//                   minWidth: 50
//                 }}
//               >
//                 Reject
//               </Button>
//             </Box>
//           )}

//           {/* ✅ Show "Awaiting Review" only for non-admin users with pending requests */}
//           {!isAdmin && request?.status === 'pending' && (
//             <Chip
//               label="Awaiting Review"
//               size="small"
//               sx={{
//                 backgroundColor: '#fff3e0',
//                 color: '#ff9800',
//                 fontSize: '0.6rem'
//               }}
//             />
//           )}
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// export default RequestCard;

import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Divider,
  Grid,
  Typography
} from '@mui/material';
import { useDrawer } from 'components/app/DrawerContext';
import React, { useState } from 'react';
import { FaEye, FaThumbsDown, FaThumbsUp } from 'react-icons/fa';
import { GrCertificate } from 'react-icons/gr';
import { SellAssetRequestItem } from 'slices/fundManagementInvestment/simulationDashboardSlice';
import CertificateViewer from '../certificate/CertificateViewer';
import {
  AssetRequest,
  ContributionRequest,
  PurchaseRequest,
  RevaluationRequest,
  SellRequest,
  TabConfig
} from './types';
import {
  formatCurrency,
  formatDate,
  formatUnits,
  getRequestDisplayData,
  getStatusConfig
} from './utils';
interface RequestCardProps {
  request:
    | PurchaseRequest
    | AssetRequest
    | RevaluationRequest
    | ContributionRequest
    | SellRequest
    | SellAssetRequestItem;
  tabConfig: TabConfig;
  onViewRequest: (
    request:
      | PurchaseRequest
      | AssetRequest
      | RevaluationRequest
      | ContributionRequest
      | SellRequest
      | SellAssetRequestItem
  ) => void;
  onAction: (
    request:
      | PurchaseRequest
      | AssetRequest
      | RevaluationRequest
      | ContributionRequest
      | SellRequest
      | SellAssetRequestItem,
    action: 'accept' | 'reject'
  ) => void;
  loading?: boolean;
}

const isSellAssetRequest = (req: any): req is SellAssetRequestItem => {
  return req && 'assetSellId' in req && 'assetId' in req && !('requestId' in req);
};

const getSellAssetRequestDisplayData = (request: SellAssetRequestItem) => {
  return {
    title: `Asset ${request.assetId}`,
    email: request.lastUpdatedBy || 'System',
    avatar: undefined,
    amount: parseFloat(request.finalPrice) || 0,
    units: parseFloat(request.deductions) || 0,
    createdAt: request.requestDate
  };
};

// Helper to check if request is for unit purchase/sell (not asset)
const isUnitRequest = (req: any): req is PurchaseRequest | SellRequest => {
  return (
    req &&
    ('investorsEmailId' in req || 'sellerEmailId' in req) &&
    'subscriptionType' in req &&
    !('assetId' in req)
  );
};

const getUserDetails = () => {
  try {
    const rawUser = localStorage.getItem('user-details');
    return rawUser ? JSON.parse(rawUser) : null;
  } catch {
    return null;
  }
};

const hasSellUnitsApprovalAccess = (): boolean => {
  const userDetails = getUserDetails();

  if (!userDetails) {
    return false;
  }

  if (userDetails?.isAdmin) {
    return true;
  }

  const roles = Array.isArray(userDetails?.role) ? userDetails.role : [];
  const roleLabels = roles
    .map((role: any) => {
      if (typeof role === 'string') return role;
      return role?.label || role?.name || role?.role_id || '';
    })
    .filter(Boolean)
    .map((label: string) => label.toLowerCase());

  return roleLabels.some(
    (label: string) => label.includes('admin') || label.includes('fund manager') || label.includes('fundmanager')
  );
};

const RequestCard: React.FC<RequestCardProps> = ({
  request,
  tabConfig,
  onViewRequest,
  onAction,
  loading = false
}) => {
  const [showCertificate, setShowCertificate] = useState(false);
  const { fundManagementAdminRight } = useDrawer();
  const isAdmin = fundManagementAdminRight;
  const canApproveSellUnits = isAdmin || hasSellUnitsApprovalAccess();

  if (!request || !tabConfig) {
    console.warn('RequestCard: Missing required props', { request, tabConfig });
    return null;
  }

  let displayData;
  if (isSellAssetRequest(request)) {
    displayData = getSellAssetRequestDisplayData(request);
  } else {
    displayData = getRequestDisplayData(request);
  }

  const statusConfig = getStatusConfig(request.status);

  if (!displayData || !statusConfig) {
    console.warn('RequestCard: Failed to get display data or status config');
    return null;
  }

  // Show certificate icon only for accepted unit purchase/sell requests
  const showCertificateIcon =
    request.status === 'accepted' &&
    // isUnitRequest(request) &&
    (tabConfig.subscriptionType === 'incomeUnits' || tabConfig.subscriptionType === 'growthUnits');

  const handleCertificateClick = () => {
    setShowCertificate(true);
  };

  const handleCertificateClose = () => {
    setShowCertificate(false);
  };

  // Map request data to certificate preview data
  const getCertificatePreviewData = () => {
    if ('investedUnits' in request) {
      // Purchase request
      const purchaseReq = request as PurchaseRequest;
      return {
        investorName: purchaseReq.investorName,
        investorEmail: purchaseReq.investorsEmailId || purchaseReq.investorEmailId || '',
        units: parseFloat(purchaseReq.investedUnits || '0'),
        unitPrice: parseFloat(purchaseReq.unitPrice || '0'),
        unitType: (request as any).unitType as 'incomeUnits' | 'growthUnits',
        transactionDate: purchaseReq.createdAt
      };
    } else if ('sellUnits' in request) {
      // Sell request, adapt to your actual SellRequest fields
      const sellReq = request as SellRequest;
      return {
        investorName: sellReq.investorName || '',
        investorEmail: sellReq?.investorEmailId || '',
        units: parseFloat(sellReq.sellUnits || '0'),
        unitPrice: parseFloat(sellReq.unitPrice || '0'),
        unitType: (request as any).unitType as 'incomeUnits' | 'growthUnits',
        transactionDate: sellReq.createdAt
      };
    }
    return null;
  };

  return (
    <>
      <Card
        sx={{
          borderRadius: 2,
          border: '1px solid #e0e0e0',
          transition: 'all 0.2s ease',
          height: '100%',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
            border: '1px solid #1976d2'
          }
        }}
      >
        <CardContent sx={{ padding: 2 }}>
          {/* Header */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
              marginBottom: 2
            }}
          >
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                flex: 1,
                minWidth: 0
              }}
            >
              <Avatar
                src={displayData.avatar || ''}
                sx={{ width: 36, height: 36, marginRight: 1.5 }}
              >
                {tabConfig.icon || '?'}
              </Avatar>
              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 500,
                    fontSize: '0.85rem',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {displayData.title || 'No Title'}
                </Typography>
                <Typography variant="caption" sx={{ color: '#666', fontSize: '0.7rem' }}>
                  {tabConfig.label || 'Unknown Type'}
                </Typography>
              </Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
              <Chip
                label={statusConfig.label || 'Unknown'}
                size="small"
                sx={{
                  backgroundColor: statusConfig.bgColor || '#f5f5f5',
                  color: statusConfig.color || '#333',
                  fontWeight: 500,
                  fontSize: '0.65rem',
                  height: 20
                }}
              />
            </Box>
          </Box>

          {/* Details - keep your existing grid */}
          <Grid container spacing={1} sx={{ marginBottom: 2 }}>
            <Grid item xs={12}>
              <Typography variant="caption" sx={{ color: '#666', fontSize: '0.65rem' }}>
                {isSellAssetRequest(request)
                  ? 'Updated By'
                  : 'investorEmailId' in request
                  ? 'Email'
                  : 'Fund Manager'}
              </Typography>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: 400 }}>
                {displayData.email || 'N/A'}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="caption" sx={{ color: '#666', fontSize: '0.65rem' }}>
                {isSellAssetRequest(request) ? 'Final Price' : 'Amount'}
              </Typography>
              <Typography sx={{ fontSize: '0.8rem', fontWeight: 500, color: '#1976d2' }}>
                {formatCurrency(displayData.amount || '0')}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#666' }}>
                {isSellAssetRequest(request)
                  ? 'Deductions'
                  : 'sellUnits' in request
                  ? 'Sell Units'
                  : 'investedUnits' in request
                  ? 'Units'
                  : 'Cash Used'}
              </Typography>
              <Typography sx={{ fontSize: '0.75rem', fontWeight: 400 }}>
                {isSellAssetRequest(request)
                  ? formatCurrency(displayData.units || '0')
                  : 'sellUnits' in request || 'investedUnits' in request
                  ? formatUnits(displayData.units || '0')
                  : formatCurrency(displayData.units || '0')}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#666' }}>
                Submitted
              </Typography>
              <Typography sx={{ fontSize: '0.7rem', fontWeight: 400 }}>
                {formatDate(displayData.createdAt || new Date().toISOString())}
              </Typography>
            </Grid>

            <Grid item xs={6}>
              <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#666' }}>
                Created
              </Typography>
              <Typography sx={{ fontSize: '0.7rem', fontWeight: 400 }}>
                {formatDate(displayData.createdAt || new Date().toISOString())}
              </Typography>
            </Grid>

            {isSellAssetRequest(request) && (
              <Grid item xs={12}>
                <Typography variant="caption" sx={{ fontSize: '0.65rem', color: '#666' }}>
                  Asset ID
                </Typography>
                <Typography
                  sx={{
                    fontSize: '0.75rem',
                    fontWeight: 400,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                  }}
                >
                  {request.assetId}
                </Typography>
              </Grid>
            )}
          </Grid>

          <Divider sx={{ marginY: 1.5 }} />

          {/* Actions */}
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }}
          >
            <Button
              startIcon={<FaEye size={12} />}
              onClick={() => onViewRequest(request)}
              sx={{
                textTransform: 'none',
                fontSize: '0.65rem',
                padding: '4px 8px'
              }}
            >
              View
            </Button>

            

            {request?.status === 'pending' && tabConfig.tabType === 'unitSell' && canApproveSellUnits ? (
              <Box sx={{ display: 'flex', gap: 0.5 }}>
                <Button
                  variant="contained"
                  size="small"
                  startIcon={<FaThumbsUp size={10} />}
                  onClick={() => onAction(request, 'accept')}
                  disabled={loading}
                  sx={{
                    backgroundColor: '#4caf50',
                    '&:hover': { backgroundColor: '#45a049' },
                    textTransform: 'none',
                    fontSize: '0.65rem',
                    padding: '4px 8px',
                    minWidth: 60
                  }}
                >
                  Accept
                </Button>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<FaThumbsDown size={10} />}
                  onClick={() => onAction(request, 'reject')}
                  disabled={loading}
                  sx={{
                    color: '#f44336',
                    borderColor: '#f44336',
                    '&:hover': { backgroundColor: '#ffebee' },
                    textTransform: 'none',
                    fontSize: '0.65rem',
                    padding: '4px 8px',
                    minWidth: 50
                  }}
                >
                  Reject
                </Button>
              </Box>
            ) : (
              isAdmin && request?.status === 'pending' ? (
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                  <Button
                    variant="contained"
                    size="small"
                    startIcon={<FaThumbsUp size={10} />}
                    onClick={() => onAction(request, 'accept')}
                    disabled={loading}
                    sx={{
                      backgroundColor: '#4caf50',
                      '&:hover': { backgroundColor: '#45a049' },
                      textTransform: 'none',
                      fontSize: '0.65rem',
                      padding: '4px 8px',
                      minWidth: 60
                    }}
                  >
                    Accept
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    startIcon={<FaThumbsDown size={10} />}
                    onClick={() => onAction(request, 'reject')}
                    disabled={loading}
                    sx={{
                      color: '#f44336',
                      borderColor: '#f44336',
                      '&:hover': { backgroundColor: '#ffebee' },
                      textTransform: 'none',
                      fontSize: '0.65rem',
                      padding: '4px 8px',
                      minWidth: 50
                    }}
                  >
                    Reject
                  </Button>
                </Box>
              ) : null
            )}

            {!isAdmin && request?.status === 'pending' && tabConfig.tabType !== 'unitSell' && (
              <Chip
                label="Awaiting Review"
                size="small"
                sx={{
                  backgroundColor: '#fff3e0',
                  color: '#ff9800',
                  fontSize: '0.6rem'
                }}
              />
            )}
          </Box>
        </CardContent>
      </Card>

      {/* Certificate Modal */}
      {showCertificate && getCertificatePreviewData() && (
        <CertificateViewer
          mode="preview"
          previewData={getCertificatePreviewData()!}
          onClose={handleCertificateClose}
        />
      )}
    </>
  );
};

export default RequestCard;
